import { IconButton, Stack, Tooltip, Typography, useTheme } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { useRef } from 'react'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import { getColorForDarkMode } from 'utils'
import { COLORS } from 'app-constants'

const TagButton = ({
  selectedTags,
  setSelectedTags,
  tagPickerAnchorEl,
  setTagPickerAnchorEl,
}: {
  selectedTags: string[]
  setSelectedTags: (selectedTags: string[]) => void
  tagPickerAnchorEl: HTMLElement | null
  setTagPickerAnchorEl: (tagPickerAnchorEl: HTMLElement | null) => void
}) => {
  const theme = useTheme()
  const isMobile = useCheckMobileScreen()

  const wrapperRef = useRef(null)

  const onCancelClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    setSelectedTags([])
    setTagPickerAnchorEl(null)
    localStorage.removeItem('selectedTags')
  }

  const onButtonClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!tagPickerAnchorEl) {
      setTagPickerAnchorEl(wrapperRef.current)
    } else {
      setTagPickerAnchorEl(null)
    }
  }

  return (
    <Stack ref={wrapperRef}>
      {selectedTags.length > 0 && (
        <Tooltip title={`Tags: ${selectedTags.join(', ')}`} placement="top">
          <Stack
            width={isMobile ? '100%' : '260px'}
            height="40px"
            px="12px"
            py="7px"
            direction="row"
            borderRadius="8px"
            spacing={1}
            onClick={(e) => {
              if (!tagPickerAnchorEl) {
                setTagPickerAnchorEl(wrapperRef.current)
              } else {
                setTagPickerAnchorEl(null)
              }
            }}
            style={{
              backgroundColor: COLORS.GRAY_0,
              cursor: 'pointer',
              color: COLORS.PURE_WHITE,
            }}>
            <Stack width="100%" direction="row" alignItems="center">
              <Typography
                variant="h6"
                sx={{
                  color: COLORS.PURE_WHITE,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                }}>
                Tag: {selectedTags[0]}{' '}
              </Typography>
              {selectedTags.length > 1 && (
                <Typography
                  variant="h6"
                  sx={{
                    color: COLORS.PURE_WHITE,
                  }}>{`+${selectedTags.length - 1}`}</Typography>
              )}
            </Stack>
            <IconButton onClick={onCancelClick} sx={{ px: 0 }}>
              <CancelIcon style={{ color: COLORS.GRAY_3 }} />
            </IconButton>
          </Stack>
        </Tooltip>
      )}
      {selectedTags.length === 0 && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width={isMobile ? '100%' : '260px'}
          height="40px"
          onClick={onButtonClick}
          border={`1px solid ${COLORS.GRAY_5}`}
          borderRadius="8px"
          pl={2}
          pr={1}
          sx={{
            cursor: 'pointer',
          }}>
          <Typography
            variant="h6"
            sx={{
              color: getColorForDarkMode(theme),
            }}>
            Tag
          </Typography>
          <KeyboardArrowDownIcon
            sx={{
              color: COLORS.GRAY_3,
            }}
          />
        </Stack>
      )}
    </Stack>
  )
}

export default function TagFilter({
  selectedTags,
  setSelectedTags,
  setTagPickerAnchorEl,
  tagPickerAnchorEl,
}: {
  selectedTags: string[]
  setSelectedTags: (selectedTags: string[]) => void
  setTagPickerAnchorEl: (tagPickerAnchorEl: HTMLElement | null) => void
  tagPickerAnchorEl: HTMLElement | null
}) {
  return (
    <TagButton
      selectedTags={selectedTags}
      setSelectedTags={setSelectedTags}
      tagPickerAnchorEl={tagPickerAnchorEl}
      setTagPickerAnchorEl={setTagPickerAnchorEl}
    />
  )
}
